import { PromoContent } from '@cinemark/content-api-client';
import { PromotionalVideoDialog } from './promotional-video-dialog/promotional-video-dialog';
import { PromotionalVideoEmbedded } from './promotional-video-embedded';

type PromotionalVideoProps = {
  dataLinkCategory: string;
  dataLinkName?: string;
  hideTitle?: boolean;
  promoContent: PromoContent;
};

export const PromotionalVideo = ({ dataLinkCategory, dataLinkName, hideTitle = false, promoContent }: PromotionalVideoProps): React.JSX.Element | null => {
  if (!promoContent) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      {!hideTitle && promoContent.promoTitle &&
        <h2 data-test="promotional-video-title">
          {promoContent.promoTitle}
        </h2>
      }

      {promoContent.isEmbedded &&
        <PromotionalVideoEmbedded dataLinkCategory={dataLinkCategory}
          dataLinkName={dataLinkName}
          promoContent={promoContent}
        />
      }

      {!promoContent.isEmbedded &&
        <PromotionalVideoDialog dataLinkCategory={dataLinkCategory}
          dataLinkName={dataLinkName}
          promoContent={promoContent}
        />
      }
    </div>
  );
};
